/**
 * 协会用户门户 - 常量定义
 * 定义会员类型、等级、状态等常量
 */

// 会员类型常量
export const MEMBER_TYPE = {
  INDIVIDUAL: 1,      // 个人会员
  ORGANIZATION: 2,    // 机构会员
  DIRECTOR: 3         // 理事会员
}

// 会员类型名称映射
export const MEMBER_TYPE_NAMES = {
  [MEMBER_TYPE.INDIVIDUAL]: '个人会员',
  [MEMBER_TYPE.ORGANIZATION]: '机构会员',
  [MEMBER_TYPE.DIRECTOR]: '理事会员'
}

// 个人会员等级常量
export const MEMBER_LEVEL = {
  UNPAID: 0,          // 未付费
  NORMAL: 1,          // 普通会员（100元）
  REGISTERED: 2       // 注册会员（300元）
}

// 会员等级名称映射
export const MEMBER_LEVEL_NAMES = {
  [MEMBER_LEVEL.UNPAID]: '未付费',
  [MEMBER_LEVEL.NORMAL]: '普通会员',
  [MEMBER_LEVEL.REGISTERED]: '注册会员'
}

// 会员等级价格映射
export const MEMBER_LEVEL_PRICES = {
  [MEMBER_LEVEL.NORMAL]: 100,
  [MEMBER_LEVEL.REGISTERED]: 300
}

// 付费状态常量
export const PAY_STATUS = {
  UNPAID: 0,          // 未打款
  PAID: 1             // 已打款
}

// 付费状态名称映射
export const PAY_STATUS_NAMES = {
  [PAY_STATUS.UNPAID]: '未打款',
  [PAY_STATUS.PAID]: '已打款'
}

// 审核状态常量
export const AUDIT_STATUS = {
  PENDING: 0,         // 待审核
  APPROVED: 1,        // 已通过
  REJECTED: 2         // 已驳回
}

// 审核状态名称映射
export const AUDIT_STATUS_NAMES = {
  [AUDIT_STATUS.PENDING]: '待审核',
  [AUDIT_STATUS.APPROVED]: '已通过',
  [AUDIT_STATUS.REJECTED]: '已驳回'
}

// 课程状态常量
export const COURSE_STATUS = {
  OFFLINE: 0,         // 下架
  ONLINE: 1           // 上架
}

// 课程状态名称映射
export const COURSE_STATUS_NAMES = {
  [COURSE_STATUS.OFFLINE]: '下架',
  [COURSE_STATUS.ONLINE]: '上架'
}

// 课程订单状态常量
export const COURSE_ORDER_STATUS = {
  NOT_ATTENDED: 0,    // 未上课
  ATTENDED: 1         // 已上课
}

// 课程订单状态名称映射
export const COURSE_ORDER_STATUS_NAMES = {
  [COURSE_ORDER_STATUS.NOT_ATTENDED]: '待上课',
  [COURSE_ORDER_STATUS.ATTENDED]: '已完成'
}

// 投诉查看状态常量
export const COMPLAINT_VIEWED_STATUS = {
  NOT_VIEWED: 0,      // 未查看
  VIEWED: 1           // 已查看
}

// 新闻状态常量
export const NEWS_STATUS = {
  NORMAL: 0,          // 正常显示
  HIDDEN: 1           // 隐藏
}

// 新闻草稿状态常量
export const NEWS_DRAFT_STATUS = {
  PUBLISHED: 0,       // 已发布
  DRAFT: 1            // 草稿
}

// 社会服务状态常量
export const SERVICE_STATUS = {
  ONLINE: 0,          // 上架
  OFFLINE: 1          // 下架
}

// 权限常量
export const PERMISSIONS = {
  COURSE_VIEW: 'course:view',           // 查看课程
  COURSE_PURCHASE: 'course:purchase',   // 购买课程
  NEWS_PUBLISH: 'news:publish',         // 发布新闻
  NEWS_EDIT: 'news:edit',               // 编辑新闻
  PROFILE_DISPLAY: 'profile:display'    // 信息展示
}

// 文件上传限制
export const FILE_UPLOAD = {
  IMAGE_MAX_SIZE: 5,                    // 图片最大5MB
  ATTACHMENT_MAX_SIZE: 10,              // 附件最大10MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png'],
  ALLOWED_ATTACHMENT_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'video/mp4', 'audio/mp3']
}

// 文件上传限制（按类型分组）
export const FILE_UPLOAD_LIMITS = {
  IMAGE: {
    MAX_SIZE: 5 * 1024 * 1024,
    ACCEPT: '.jpg,.jpeg,.png,.gif'
  },
  FILE: {
    MAX_SIZE: 10 * 1024 * 1024,
    ACCEPT: '.pdf,.doc,.docx,.xls,.xlsx'
  },
  VIDEO: {
    MAX_SIZE: 50 * 1024 * 1024,
    ACCEPT: '.mp4,.avi,.mov'
  },
  AUDIO: {
    MAX_SIZE: 20 * 1024 * 1024,
    ACCEPT: '.mp3,.wav,.aac'
  }
}

// 验证码配置
export const VERIFICATION_CODE = {
  LENGTH: 6,                            // 验证码长度
  EXPIRE_TIME: 5 * 60 * 1000,          // 过期时间：5分钟
  RESEND_INTERVAL: 60 * 1000           // 重发间隔：1分钟
}

// 会话配置
export const SESSION = {
  TIMEOUT: 24 * 60 * 60 * 1000         // 会话超时：24小时
}

// 订单类型常量
export const ORDER_TYPES = {
  COURSE: 1,          // 课程订单
  MEMBERSHIP: 2       // 会员订单
}

// 支付方式常量
export const PAYMENT_METHODS = {
  ALIPAY: 1,          // 支付宝
  WECHAT: 2,          // 微信支付
  BANK: 3             // 银行转账
}

// 支付方式名称映射
export const PAYMENT_METHOD_NAMES = {
  [PAYMENT_METHODS.ALIPAY]: '支付宝',
  [PAYMENT_METHODS.WECHAT]: '微信支付',
  [PAYMENT_METHODS.BANK]: '银行转账'
}
